<template>
    <div class="categories-filters bg-light" >
        <ul v-if="filters && filters.length > 0" class="filter-list main-content">
            <li>
                <button role="option" class="btn-filter btn" :class="{ 'active' : !(activeFilters.length) }" @click="nullFilters" :aria-selected=" (activeFilters.length)? 'false' : 'true'">Vis alle</button>
            </li>
            <li v-for="(filter, i) in filters" :key="i">
                <button 
                    role="option" 
                    @click="selectFilter(filter.id)" 
                    :aria-selected=" (activeFilters.indexOf(filter.id) !== -1)? 'true' : 'false'" 
                    :class="{ 'active' : (activeFilters.indexOf(filter.id) !== -1 ) }" 
                    class="btn btn-filter">{{filter.name}}</button>
            </li>
        </ul>
        <slot></slot>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'categories-filters',
    data() {
        const VM = this;
        return {
            activeFilters: [],
        }
    },
    props: { 
        taxonomy:{
            type: String,
            default: 'categories'
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    computed:{
        ...mapGetters([
            'getTaxonomy',
        ]),
        filters(){
            const tax = this.taxonomy.toLowerCase()
            let filters = null;
            if(tax === 'posttypes'){
                filters = [];
                const PostTypes = window.WPVUE.post_types;
                Object.keys(PostTypes).forEach(function (item) {
                    if(item !== 'attachment') filters.push({
                        'name' : PostTypes[item].labels.name,
                        'id' : item
                    })
                });
            }else{
                filters = this.getTaxonomy(this.taxonomy);
            }
            return filters;
        }
    },
    mounted() {
        const VM = this;
        const tax = this.taxonomy.toLowerCase();
        let elTest = false;
        if(VM.$route.query.kategori){
            let query = VM.$route.query.kategori;
            let taxfilt = this.filters.map( (it)=> (it.id));
            if(tax !== 'posttypes'){
                query = Number(query);
            }

            elTest = taxfilt.indexOf(query);
            if(elTest !== -1){
                this.activeFilters = [query]
            }
        } 
        this.$emit('filters', this.activeFilters )
    },
    watch: {
        activeFilters(val){
            this.$emit('filters', val)
        }
    },
    methods: {
       
        nullFilters(){
            this.activeFilters = [];
        },
        selectFilter(filterItemId){
            const elTest = this.activeFilters.indexOf(filterItemId); // check element in array - retutn -1 if null
            if(!this.multiple){
                this.nullFilters();
            }
            if(elTest !== -1){
                this.activeFilters.splice(elTest , 1) // remove if exist
            }else{
                this.activeFilters.push(filterItemId) // edd if not exist
            }
        },
    },
};
</script>


<style lang="scss">
</style>
